// extracted by mini-css-extract-plugin
export default {"FormBody":"Create_FormBody__16VJG"};